export default {
	common: {
		clearSelection: "Annulla selezione",
		delete: "Elimina",
		close: "Chiudi",
	},
	catalogue: {
		pendingOrdersTitle: "Ordini in sospeso",
		pendingOrdersDescription:
			"I seguenti ordini sono stati richiesti dai rispettivi utenti, ma non sono ancora stati approvati.",
		uploadButtonTooltip: "Selezionare e caricare articoli.",
		importTitle: "Importazione articoli",
		importHint:
			"Trascinare fino a 10 file (.step / .stp / .dxf) in quest'area oppure premere il pulsante",
		emptyHint: "Ancora un po' vuoto qui...",
		importInstructions:
			"Importi i Suoi modelli CAD in formato .step o .dxf trascinando i file in quest'area, oppure clicchi sul pulsante sopra per selezionare i file.",
		importProcessDescription:
			"Blexon importa quindi le Sue parti, ne verifica la fattibilità e calcola automaticamente i prezzi.",
		videoIntro: "Il video mostra i primi passi con Blexon",
		videoTitle:
			"Ecco come caricare facilmente modelli CAD su Blexon e ordinare direttamente online lamiere tagliate al laser su misura",
		searchLabel: "Cerca articolo:",
		searchPlaceholder: "Inserire nome o numero articolo...",
		sortingLabel: "Ordinamento:",
		userFilterLabel: "Mostra articoli di:",
		loadMoreTooltip: "Carica altri articoli con le impostazioni di filtro attuali.",
		loadMoreButton: "Carica altri",
		sortTypes: {
			createdDescending: "Creati di recente per primi",
			createdAscending: "Creati di recente per ultimi",
			lastChangeDescending: "Modificati di recente per primi",
			lastChangeAscending: "Modificati di recente per ultimi",
			nameAscending: "Per nome articolo A - Z",
			nameDescending: "Per nome articolo Z - A",
			materialNameAscending: "Per denominazione materiale A - Z",
			materialNameDescending: "Per denominazione materiale Z - A",
			materialThicknessAscending: "Per spessore materiale (sottile prima)",
			materialThicknessDescending: "Per spessore materiale (spesso prima)",
		},
		uploadWarningDialog: {
			title: "File incompatibili",
			invalidFormatText: "I seguenti file hanno un formato non valido e non possono essere caricati:",
			errorText:
				"I seguenti file superano la dimensione massima consentita e non possono essere caricati:",
			warningText: "I seguenti file sono molto grandi e non verranno elaborati automaticamente:",
			warningHint:
				"Definisca per questi articoli il materiale adatto e lo spessore corretto. Dopo la blexonizzazione, gli articoli verranno aggiunti al Suo catalogo. Da lì potrà inviare gli articoli al nostro helpdesk per la verifica.",
			moreInfo:
				"Ulteriori informazioni sulle dimensioni dei file consentite e sulle cause di modelli CAD di grandi dimensioni sono disponibili nel nostro {blog}.",
			blogLinkText: "blog",
		},
		messages: {
			maxFilesExceeded: "È possibile caricare al massimo 10 modelli CAD contemporaneamente.",
		},
	},
	assembly: {
		processing: "Elaborazione del gruppo in corso...",
		back: "Indietro",
		title: "Gruppo: {articleId} | '{articleName}'",
		multiDeleteDialog: {
			title: "Eliminare più articoli",
			deleting: "Eliminazione degli articoli in corso...",
			invalidStateText:
				"I seguenti articoli sono bloccati oppure sono attualmente in fase di calcolo e quindi {not} possono essere eliminati:",
			notWord: "non",
			confirmText: "Vuole davvero eliminare {count} articoli?",
			noneDeletable: "Nessuno degli articoli selezionati può essere eliminato.",
			deleteButton: "Elimina",
		},
		messages: {
			deleteError: "Errore durante l'eliminazione di un articolo.",
		},
	},
	multiedit: {
		deleteButton: "Elimina {count} articoli",
		powderCoatButton: "Verniciare a polvere {count} articoli",
		powderCoatTooltip:
			"Aggiunge, modifica o rimuove una verniciatura a polvere per tutti gli articoli selezionati.",
		zincCoatButton: "Zincare {count} articoli",
		zincCoatTooltip:
			"Aggiunge, modifica o rimuove una zincatura per tutti gli articoli selezionati.",
	},
	multieditAssembly: {
		deleteButton: "Elimina {count} articoli",
	},
	importArticle: {
		uploading: "Caricamento in corso...",
		articleNameLabel: "Nome articolo",
		articleNumberLabel: "Numero articolo (facoltativo)",
		articleNumberPlaceholder: "Il Suo numero articolo",
		quantityInAssembly: "{count} pezzi",
		thickness: "Spessore: {thickness}mm",
		noMaterialFoundHintMain:
			"Non abbiamo trovato alcun materiale con lo spessore rilevato. Selezioni il materiale desiderato dall'elenco e blexonizzi l'articolo. Se si verifica un errore, può inviare l'articolo al nostro helpdesk per la verifica.",
		noMaterialFoundHintSubArticle:
			'Non abbiamo trovato alcun materiale con lo spessore rilevato. Le consigliamo di eliminare gli inserti a pressione con il "cestino" a destra e di definirli successivamente nel visualizzatore CAD. In questo modo può rimuovere anche le "parti non in lamiera" prima della lavorazione.',
		materialPlaceholder: "Selezionare un materiale...",
		thicknessPlaceholder: "Selezionare uno spessore...",
		pressJoinPlaceholder: "... oppure selezioni un inserto a pressione",
		noPressJoinsAvailable: "Nessun inserto a pressione disponibile",
		deleteTooltip: "Interrompe il processo di importazione ed elimina l'articolo dall'elenco.",
		deleteSubArticleTooltip: "Rimuove questo corpo solido dal modello.",
		blexonisierenButton: "Blexonizza",
		blexonisierenTooltip:
			"Analizza l'articolo e rileva automaticamente le lavorazioni. Il calcolo del prezzo viene avviato.",
		pressJoinCategories: {
			selfClinchingNuts: "Dadi autoclinching",
			selfClinchingThreadedStud: "Perni filettati autoclinching",
			selfClinchingThreadedStandoff: "Boccole filettate autoclinching",
		},
		messages: {
			deleteError: "Non è stato possibile eliminare l'articolo.",
		},
	},
	importAssembly: {
		articleNameLabel: "Nome articolo",
		articleNumberLabel: "Numero articolo (facoltativo)",
		articleNumberPlaceholder: "Il Suo numero articolo",
		assemblyProcessingText: "Oh, un gruppo. Allora lo scomponiamo...",
		materialPlaceholderAvailable: "Selezionare un materiale...",
		materialPlaceholderUnavailable: "Nessun materiale comune disponibile per tutte le parti",
		materialHint:
			"Questo materiale non è disponibile per tutte le parti. Selezioni singolarmente i materiali mancanti qui sotto.",
		deleteTooltip: "Interrompe il processo di importazione ed elimina l'articolo dall'elenco.",
		blexonisierenButton: "Blexonizza",
		blexonisierenTooltip:
			"Analizza il gruppo e rileva automaticamente le lavorazioni. Il calcolo del prezzo viene avviato.",
		messages: {
			deleteError: "Non è stato possibile eliminare l'articolo.",
		},
	},
	pendingOrder: {
		summary: "Ordine in sospeso del {date} di {firstname} {lastname} ({count} posizioni)",
		addToCartTooltip: "Aggiunge l'ordine al carrello.",
		addToCartButton: "Nel carrello",
		deleteTooltip: "Elimina l'ordine.",
		deleteDialog: {
			title: "È sicuro?",
			text: "L'ordine di {firstname} {lastname} con {count} posizioni deve essere eliminato? Questa operazione non può più essere annullata.",
		},
	},
};
